import { QueryClient } from "@tanstack/react-query";

export const REACT_QUERY_CACHE_MAX_AGE_MS = 1000 * 60 * 60 * 24;

export function createQueryClient() {
	return new QueryClient({
		defaultOptions: {
			queries: {
				gcTime: REACT_QUERY_CACHE_MAX_AGE_MS,
				staleTime: 60_000,
				refetchOnWindowFocus: false,
			},
		},
	});
}
